/*
-------------------------------------------------------------------------
Copyright (c) 2026 - Y-Times Publications, LLC. All rights reserved.
Unauthorized duplication prohibited without publisher's written consent.
https://www.ytimes.com | info@ytimes.info
DEV: Zoltan 'Zoli' Varga | zoltan@ytimes.com
FILE: ytimes-addon-options-plugin.js
-------------------------------------------------------------------------
*/

var YTIMES = window.YTIMES || (window.YTIMES = {});

YTIMES.AddonOptions = (() => {

	const state = {
		selectedAddons: {
			1: null,
			2: null,
			3: null
		}
	};

	const init = () => {
		const container = document.getElementById("ytmAddonOptions");
		if (!container) return;
		const form = document.querySelector('form.js-product-form-main');
		if (!form) return;
		bindAddonEvents();
		form.addEventListener('submit', (e) => {
			if (!validateAddons()) {
				e.preventDefault();
				e.stopPropagation();
				showValidationError('Please select an option for each add-on before adding this product to your cart.');
				return;
			}
			e.preventDefault();
			e.stopPropagation();
			void addToCartWithAddons();
		}, true);
	};

	const bindAddonEvents = () => {
		const container = document.getElementById("ytmAddonOptions");
		if (!container) return;
		container.addEventListener("click", (e) => {
			const btn = e.target.closest(".ytm-addon-option");
			if (!btn) return;
			const group = btn.dataset.group;
			const variantId = btn.dataset.variantId;
			if (!group || !variantId) return;

			handleAddonSelection(group, variantId, btn);
		});
	};

	const handleAddonSelection = (group, variantId, btn) => {
		const optVarContainer = document.getElementById("OptionVariantSelector");
		const groupContainer = btn.closest(".ytm-addon-group");
		groupContainer.classList.remove("yt-has-error");
		if ( btn.classList.contains("collection") ) {
			state.selectedAddons[group] = variantId;
			groupContainer
				.querySelectorAll(".ytm-addon-option")
				.forEach(el => el.classList.remove("selected"));
			btn.classList.add("selected");
			let OptVarContainer = document.getElementById("OptionVariantSelector");
			if ( OptVarContainer && OptVarContainer.innerHTML.trim() === "" ) {
				// generate and show the variants
				YTIMES.OptionVariants.init();
			}
			else {
				// only show the variants
				if ( optVarContainer.scrollHeight > 500 ) {
					optVarContainer.style.maxHeight = `${Math.max(500, optVarContainer.scrollHeight)}px`;
				}
				optVarContainer.classList.remove("hidden");
				setTimeout(function() {
					optVarContainer.style.overflow = 'visible';
				}, 500);
			}
		}
		else {
			if (btn.classList.contains("selected")) return;
			groupContainer
				.querySelectorAll(".ytm-addon-option")
				.forEach(el => el.classList.remove("selected"));
			btn.classList.add("selected");
			state.selectedAddons[group] = variantId;
			// hide variants
			optVarContainer.style.overflow = 'hidden';
			optVarContainer.classList.add("hidden");
		}
		if (typeof YTIMES.CountSubTotal === 'function') {
			YTIMES.CountSubTotal();
		}
	};

	const updateSelection = (group, variantId) => {
		if (!group || !variantId) return;
		// Only update an already selected add-on group.
		if (!Object.prototype.hasOwnProperty.call(state.selectedAddons, group)) {
			return;
		}
		state.selectedAddons[group] = variantId;
		YTIMES.CountSubTotal();
	};

	const validateAddons = () => {
		const groups = document.querySelectorAll('#ytmAddonOptions .ytm-addon-group');
		let valid = true;
		groups.forEach(group => {
			const selected = group.querySelector('.ytm-addon-selections button.ytm-addon-option.selected');
			if (!selected) {
				group.classList.add('yt-has-error');
				valid = false;
			}
		});
		return valid;
	};

	const showValidationError = (message) => {
		let popup = document.getElementById('ytmValidationError');
		if (popup) {
			popup.remove();
		}
		popup = document.createElement('div');
		popup.id = 'ytmValidationError';
		popup.innerHTML = `
			<div class="ytm-validation-overlay">
				<div class="ytm-validation-popup">
					<button type="button" class="ytm-validation-close" aria-label="Close">&times;</button>

					<div class="ytm-validation-message">
						${message}
					</div>

					<button type="button" class="ytm-validation-ok">Close</button>
				</div>
			</div>
		`;
		document.body.appendChild(popup);

		const closePopup = () => {
			const firstError = document.querySelector('.yt-has-error');
			popup.remove();
			if (firstError) {
				firstError.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
				firstError.classList.add('yt-pulse-error');
				setTimeout(() => {
					firstError.classList.remove('yt-pulse-error');
				}, 4000);
			}
		};
		popup.querySelector('.ytm-validation-close').addEventListener('click', closePopup);
		popup.querySelector('.ytm-validation-ok').addEventListener('click', closePopup);
	};

	const addToCartWithAddons = async () => {
		const items = [];
		const mainProdId = document.querySelector('[name="id"]')?.value;
		const quantityInput = document.querySelector('[name="quantity"]');
		const quantity = parseInt(quantityInput?.value, 10) || 1;
		const configId = crypto.randomUUID();

		if (!mainProdId) return;

		Object.values(state.selectedAddons).forEach(addOn => {
			if (!addOn || String(addOn) === '67658784407646' || String(addOn) === '67995830190116') return;
			items.push({
				id: String(addOn),
				quantity: quantity
			});
		});

		items.push({
			id: String(mainProdId),
			quantity: quantity
		});

		try {
			const result = await YTIMES.AddonCart.addCartItems(items);
		} catch (error) {
			console.error('Cart add failed:', error);
			alert(error.message || 'Unable to add products to cart.');
		}	
	};

	return { init, state, updateSelection };
})();


YTIMES.OptionVariants = (() => {
	const optionVariants = window.optionVariantsPlugin[0];
	const state = {
		initialized: false,
		schemaArray: [],
		schemaMap: {},
		products: [],
		selectedOptions: {}
	};

	const init = () => {
		if ( !optionVariants || !optionVariants.enabled ) {
			console.warn("YTIMES OptionVariants: plugin disabled or missing data.");
			return;
		}
		state.schemaArray = parseSchema(optionVariants.rawVariantDefinition);
		state.schemaMap = buildSchemaMap(state.schemaArray);

		state.products = normalizeProducts(
			optionVariants.products,
			state.schemaArray
		);

		initializeSelectedOptions();
		buildUI();
		applySelectedStates();
		updateAvailabilityStates();
		bindEvents();

		selectSingleOptions();
	};

	const parseSchema = (raw) => {
		if (!raw || typeof raw !== "string") return [];
		return raw.split("\n").map(line => line.trim()).filter(Boolean).map(line => {
			const [key, label, type] = line.split("|").map(s => s.trim());
			if (!key || !label || !type) return null;
			return {
				key,
				label,
				type
			};
		}).filter(Boolean);
	};

	const buildSchemaMap = (schemaArray) => {
		return schemaArray.reduce((acc, item) => {
			acc[item.key] = {
				label: item.label,
				type: item.type
			};
			return acc;
		}, {});
	};

	const normalizeProducts = (products, schemaArray) => {
		return products.map(product => {
			const variantValues = {};
			schemaArray.forEach(schema => {
				const [group, key] = schema.key.split(".");
				variantValues[schema.key] = product.variantValues?.[group]?.[key] ?? null;
			});
			return {
				id: product.id,
				handle: product.handle,
				url: product.url,
				title: product.title,
				variantValues,
				raw: product
			};
		});
	};

	const getUniqueVariantValues = (key, type) => {
		if (!state.products || !state.products.length) return [];
		const values = state.products
			.map(p => p.variantValues?.[key])
			.filter(v => v);
		const unique = [...new Set(values)];
		const order = variantSortOrder[key];
		if (order) {
			return unique.sort((a, b) => {
				return order.indexOf(a) - order.indexOf(b);
			});
		}
		return unique.sort((a, b) => a.localeCompare(b));
	};

	const buildUI = () => {
		const container = document.getElementById("OptionVariantSelector"); //data-variant-id
		if (!container) {
			console.warn("OptionVariant UI container missing");
			return;
		}
		container.innerHTML = "";
		state.schemaArray.forEach(schema => {
			const values = getUniqueVariantValues(schema.key, schema.type);
			const group = document.createElement("div");
			group.className = "ytm-option-variant-group";
			const label = document.createElement("div");
			label.className = "ytm-option-variant-label";
			label.innerHTML = schema.label + ' <span class="icon round popup" data-popupid="' + schema.label.toLowerCase().replace(/\s+/g, '_') + '" data-popupfield="' + schema.key + '">?</span>';
			const options = document.createElement("div");
			options.className = "ytm-option-variant-options";
			values.forEach(value => {
				const button = document.createElement("button");
				button.type = "button";
				button.className = "ytm-option-variant-option";
				button.dataset.key = schema.key;
				button.dataset.value = value;

				switch (schema.type) {
					case 'swatch': {
						const iconValue = getVariantIcon(schema.type, value, schema.key);
						let label = document.createElement("span");
						if ( !iconValue.startsWith('https://') ) {
							
							label.className = "ytm-option-variant-only-label";
							label.textContent = iconValue;
						}
						else {
							const img = document.createElement("img");
							img.className = "ytm-option-variant-icon";
							img.alt = value;
							img.src = iconValue;
							label.className = "ytm-option-variant-icon-label";
							label.textContent = value;
							button.appendChild(img);
						}
						button.appendChild(label);
						break;
					}

					case 'textbox': {
						let label = document.createElement("span");
						label.className = "ytm-option-variant-textbox";
						label.textContent = value;
						button.appendChild(label);
						break;
					}

					case 'dropdown': {
						break;
					}
				}

				options.appendChild(button);
			});
			group.appendChild(label);
			group.appendChild(options);
			container.appendChild(group);
		});
		if ( container.scrollHeight > 500 ) {
			container.style.maxHeight = `${Math.max(500, container.scrollHeight)}px`;
		}
		container.classList.remove("hidden");
		setTimeout(function() {
			container.style.overflow = 'visible';
		}, 500);
	};

	const initializeSelectedOptions = () => {
		const currentProduct = state.products.find( product => product.id === optionVariants.starterProductId );
		if ( !currentProduct ) {
			console.warn("Current product not found in option-variant products.");
			return;
		}
		state.selectedOptions = {
			...currentProduct.variantValues
		};
	};

	const applySelectedStates = () => {
		const buttons = document.querySelectorAll(".ytm-option-variant-option");
		buttons.forEach(button => {
			const key = button.dataset.key;
			const value = button.dataset.value;
			const isSelected = (
				state.selectedOptions[key] === value
			);
			button.classList.toggle("is-selected", isSelected);
		});
	};

	const bindEvents = () => {
		const buttons = document.querySelectorAll(".ytm-option-variant-option");
		buttons.forEach(button => {
			button.addEventListener("click", () => {
				if (button.classList.contains("inactive")) return;
				const key = button.dataset.key;
				const value = button.dataset.value;
				if (state.selectedOptions[key] === value) return;
				updateSelectedOption(key, value);
			});
		});
		const popIcons = document.querySelectorAll(".ytm-option-variant-label span.icon.popup");
		popIcons.forEach(icon => {
			let popup = null;
			let popupText = null;
			const popupId = icon.dataset.popupid;
			icon.addEventListener("mouseenter", () => {
				const overrideText = optionVariants?.tooltipOverrides?.[icon.dataset.popupfield];
				if ( overrideText ) {
					popupText = overrideText;
				}
				else {
					popupText = iconPopups[popupId];
				}
				if (!popupText) return;
				if (!popup) {
					popup = document.createElement("div");
					popup.className = "ytm-tooltip";
					popup.innerHTML = popupText;
					icon.appendChild(popup);
				}
				popup.classList.add("visible");
			});
			icon.addEventListener("mouseleave", () => {
				const popup = icon.querySelector(".ytm-tooltip");
				if ( popup ) {
					popup.classList.remove("visible");
				}
			});
		});
	};

	const updateSelectedOption = (key, value) => {
		state.selectedOptions[key] = value;
		const optionIndex = state.schemaArray.findIndex(
			option => option.key === key
		);
		state.schemaArray
			.slice(optionIndex + 1)
			.forEach(option => {
				delete state.selectedOptions[option.key];
			});
		applySelectedStates();
		updateAvailabilityStates();
		const product = findMatchingProduct();
		if (product) {
			updateAddonProduct(product);
		}
	};

	const updateAvailabilityStates = () => {
		const buttons = document.querySelectorAll(".ytm-option-variant-option");
		buttons.forEach(button => {
			const key = button.dataset.key;
			const value = button.dataset.value;
			const isValid = isOptionAvailable(key, value);
			button.classList.toggle("inactive", !isValid);
		});
	};

	const isOptionAvailable = (key, value) => {
		const currentIndex = state.schemaArray.findIndex(
			option => option.key === key
		);
		const controllingOptions = state.schemaArray.slice(0, currentIndex);
		return state.products.some(product => {
			const matchesPreviousSelections = controllingOptions.every(option => {
				const selectedValue = state.selectedOptions[option.key];
				if (!selectedValue) return true;
				return product.variantValues[option.key] === selectedValue;
			});
			if (!matchesPreviousSelections) return false;
			return product.variantValues[key] === value;
		});
	};

	const findMatchingProduct = () => {
		const matches = findMatchingProducts();
		return matches.length === 1 ? matches[0] : null;
	};
	const findMatchingProducts = () => {
		return state.products.filter(product => {
			return Object.entries(state.selectedOptions).every(([key, value]) => {
				// Ignore options that haven't been selected yet
				if (!value) return true;
				return product.variantValues[key] === value;
			});
		});
	};

	const navigateToProduct = (handle) => {
		/*
		const currentPath = window.location.pathname;
		const targetPath = `/products/${handle}`;
		if (currentPath === targetPath) return;
		if (window.__ytimesNavigating) return;
		window.__ytimesNavigating = true;
		window.location.href = targetPath;
		*/
	};
	const updateAddonProduct = (product) => {
		const btn = document.querySelector('button[data-collection-id="' + optionVariants.collection.id + '"]');
		btn.dataset.productId = product.raw.id;
		btn.dataset.variantId = product.raw.variantid;
		btn.querySelector('img').src = product.raw.thumb;
		btn.querySelector('img').alt = product.raw.title;
		btn.querySelector('span.title').innerHTML = product.raw.title;
		YTIMES.AddonOptions.updateSelection(
			btn.dataset.group,
			product.raw.variantid
		);
	};

	const selectSingleOptions = () => {
		document.querySelectorAll('.ytm-addon-group').forEach(group => {
			const options = group.querySelectorAll('.ytm-addon-option');
			if (options.length === 1 && options[0].querySelector('.is-free')) { // old condition: options.length === 1 && Number(options[0].dataset.price) === 0
				options[0].click();
			}
		});
	};

	const getVariantIcon = (schemaType, value, fieldname) => {
		const overrideIcon = optionVariants?.iconMapOverrides?.[fieldname]?.[value];
		if (overrideIcon) {
			return overrideIcon;
		}

		const iconMap = {
			"custom.size": {
				"Small":		"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-size-small-cat.svg",
				"Medium":		"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-size-small.svg",
				"Large":		"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-size-medium.svg",
				"Extra Large":	"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-size-large.svg"
			},
			"custom.type": {
				"Standard":		"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-icon-standard.svg",
				"WiFi":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-icon-wifi.svg"
			},
			"custom.height": {
				"Regular":		"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-height-patio-regular.svg",
				"Tall":			"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-height-patio-tall.svg"
			},
			"custom.mounting": {
				"Door":			"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-door.svg",
				"Wall":			"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-wall.svg",
				"Patio":		"https://cdn.shopify.com/s/files/1/0595/1566/6468/files/htp-icon-patio.svg"
			},
			"custom.collar_size": {
				"Cat":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-icon-size-small-cat.svg",
				"Dog":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-icon-size-medium.svg"
			},
			"custom.collar_pattern": {
				"Mac":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-paws-pink-mac.jpg",
				"Modern":		"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-modern.jpg",
				"Paws":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-paws.jpg",
				"Tribal":		"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-paws-pink-tribal.jpg",
				"Camo":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-camo.jpg",
				"Black":		"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-paws-pink-black.jpg",
				"Blue":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-blue.jpg",
				"Orange":		"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-orange.jpg",
				"Pink":			"https://cdn.shopify.com/s/files/1/0649/5073/0846/files/htp-collar-swatches-paws-pink.jpg"
			}

		};
		return iconMap?.[fieldname]?.[value] || "";
	};
	const variantSortOrder = {
		"custom.size": [
			"Small",
			"Medium",
			"Large",
			"Extra Large"
		],
		"custom.type": [
			"Standard",
			"WiFi"
		],
		"custom.height": [
			"Regular",
			"Tall"
		],
		"custom.mounting": [
			"Door",
			"Wall",
			"Patio"
		],
		"custom.collar_size": [
			"Cat",
			"Dog"
		],
		"custom.collar_pattern": [
			"Mac",
			"Modern",
			"Paws",
			"Tribal",
			"Camo",
			"Black",
			"Blue",
			"Orange",
			"Pink"
		]
	};

	const iconPopups = {
		"size": "Choose a pet door size that allows your pet to pass through comfortably. Measure your pet\'s width at the shoulders and height at the tallest point of the back.<br><br><B>Medium:</B> 73\" W × 15\" H (up to 30 lbs)<br><B>Large:</B> 10\" W × 19\" H (up to 100 lbs)<br><B>Extra Large:</B> 12\" W × 23\" H (up to 200 lbs)<br><br>When in doubt, select the larger size to ensure comfortable daily use.",
		"type": "Choose the control type of your pet door. Between standard or wifi enabled functionality for your personal needs.",
		"mounting": "Where will your pet door be installed? Select Door Mount, Wall Mount, or Patio Mount to ensure you receive the version designed for your home's specific installation requirements.",
		"height": "Select the panel height that matches your installation opening. Regular models fit most standard patio door frames, while Tall models are designed for taller patio door openings. This option does not affect the pet door opening size.",
		"collar_size": "Select something...",
		"collar_pattern": "Select something..."
	};

	return { init, state, selectSingleOptions };
})();

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		YTIMES.AddonOptions.init();
		YTIMES.OptionVariants.selectSingleOptions();
	});
} 
else {
	YTIMES.AddonOptions.init();
	YTIMES.OptionVariants.selectSingleOptions();
}